import ReactDOM from 'react-dom'
import { useLegacyProductsListPpeProductsQuery } from 'codegen/generated/cf'
import * as Sentry from '@sentry/nextjs'

import { contentDownloadAssetQueryFetcher } from '@web/gen/content'
import type { ContentDownloadAssetQuery } from '@web/gen/mocks'
import { ContentDownloadSource } from '@web/gen/mocks'

export async function getAssetUrl(assetId: string, assetPath: string) {
  let data: ContentDownloadAssetQuery | undefined
  try {
    data = await contentDownloadAssetQueryFetcher({
      ids: [assetId],
      source: ContentDownloadSource.Website,
    })()
  } catch (error) {
    Sentry.captureException(
      new Error(
        `Error while getting download asset for asset: ${assetId}:
          error = ${(error as Error)?.message ? (error as Error)?.message : (error as string)}`,
      ),
    )
  }

  return {
    href: data?.contentDownloadAssets[0]?.url ?? '',
    download: `${assetId}.${assetPath.split('.').pop() || ''}`,
    payment: data?.contentDownloadAssets[0]?.paymentRequired ?? false,
  }
}

export async function prefetchSuggestions(limit: number) {
  try {
    const response = await useLegacyProductsListPpeProductsQuery.fetcher({
      limit,
      offset: 0,
    })()
    response.legacyProductsListPPEProducts.products.forEach(product => {
      product.image &&
        ReactDOM.preload(product.image, {
          // @ts-ignore -- This is needed because image is not yet defined in the type https://react.dev/reference/react-dom/preload#parameters but is a valid option https://developer.mozilla.org/en-US/docs/Web/HTML/Element/link#as
          as: 'image',
          crossOrigin: 'anonymous',
        })
    })
  } catch (error) {
    Sentry.captureException(
      new Error(
        `Error while fetching suggestions:
          error = ${(error as Error)?.message ? (error as Error)?.message : (error as string)}`,
      ),
    )
  }
}

export function getIsMobileSafari() {
  const userAgent = navigator.userAgent || navigator.vendor
  return /iP(ad|hone|od).+Version\/[\d.]+.*Safari/i.test(userAgent)
}

export function getIsMacOsSafari() {
  const userAgent = navigator.userAgent || navigator.vendor
  return /Macintosh/i.test(userAgent) && /Safari/i.test(userAgent)
}

// oxlint-disable-next-line require-await
export async function downloadAsset(fileUrl: string, fileName: string) {
  const link = document.createElement('a')
  link.style.display = 'none'
  link.download = fileName
  link.href = fileUrl

  document.body.appendChild(link)
  link.click()
  link.parentNode?.removeChild(link)
}
